<template>
  <div v-if="this.loggedInUser" class="dashboard-screen">
    <page-header :title="$t('app.dashboard.title')" />
    <div class="row mt-30">
      <div class="col-sm-3">
        <base-dropdown
          :list="sites"
          v-model="siteId"
          :defaultValue="siteId"
          :needDefaultValue="false"
          labelClassNames="control-label mb-10 text-left"
          :labelValue="$t(`app.inspections.filter.site_id`)"
          @input="filterBySite"/>
      </div>
    </div>
    <div>
      <div class="">
        <div v-if="dashboardData" class="row dasboard-row">
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-6">
                <div class="row" style="height: 358px; display: flex; flex-direction: column;">
                  <dashboard-card
                    :colSize="'col-sm-12'"
                    :iconClass="'ti-eye'"
                    :count="dashboardData.inspection_info.inspections_count"
                    :percent="inspectionPercent"
                    :activeLabel="$t('app.dashboard.labels.inspections.active')"
                    :inactiveLabel="$t('app.dashboard.labels.inspections.inactive')"
                    :title="'app.dashboard.inspections'"
                  />
                  <div style="height: 7px"></div>
                  <dashboard-card
                    :colSize="'col-sm-12'"
                    :iconClass="'ti-flag'"
                    :count="dashboardData.statement_count"
                    :title="'app.dashboard.statements'"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <activity-chart
                  :chartTitle="$t('app.dashboard.activityChartTitle')"
                  :colClasses="'col-sm-12'"
                  :chartStyle="'height: 358px; display: flex; justify-content: center; flex-direction: column;  '"
                  :needOptions="false"
                  :options="options"
                  :series="series"
                  />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12" style="padding-left: 6px; padding-right: 21px;">
                <vue-cal
                :selected-date="this.today()"
                :time-from="9 * 60"
                :disable-views="['years', 'year', 'week', 'day']"
                default-view="month"
                events-on-month-view="short"
                :locale="calendarLocale"
                :events="tasks"
                style="height: 600px"
                :on-event-click="onEventClick"
              >
              </vue-cal>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-12 col-xs-12" ref="donutPanel">
                <div
                  class="panel panel-default border-panel card-view panel-refresh"
                >
                  <div class="refresh-container">
                    <div class="la-anim-1"></div>
                  </div>
                  <div class="panel-heading">
                    <div class="pull-left">
                      <h6 class="panel-title txt-dark">
                        {{ $t("app.dashboard.tasks") }}
                      </h6>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="panel-wrapper collapse in">
                    <div class="panel-body donut-panel" style="height: 303px">
                      <apexchart
                        v-if="donutOptions['sum'] > 0"
                        type="donut"
                        :height="'255px'"
                        :options="donutOptions"
                        :series="donutOptions['series']"
                      ></apexchart>
                      <span v-if="donutOptions['sum'] === 0" class="txt-dark">{{
                        this.$t("app.dashboard.noData")
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <activity-feed
                :panelHeight="'600px'"
                :maxHeight="'545px'"
                :totalPages="this.notificationPages"
                @loadNext="loadNext"
                :data="timeLine"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isLoading&&isloading==true" class="page-wrapper loading-wrapper ml-0">
      <span class="loading-text">{{$t('app.listLoading')}}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ApexCharts from 'apexcharts';
import VueCal from 'vue-cal';
import 'vue-cal/dist/i18n/sr.js';
import 'vue-cal/dist/i18n/hu.js';
import 'vue-cal/dist/vuecal.css';
import PageHeader from '@/components/shared/layouts/PageHeader';
import BaseButton from '@/components/shared/buttons/BaseButton';
import ConfigurableList from '@/components/shared/lists/ConfigurableList';
import BaseDropdown from '@/components/shared/inputs/BaseDropDown';
import DashboardCard from './DashboardCard';
import ActivityFeed from './ActivityFeed';
import ActivityChart from './ActivityChart';

export default {
  name: 'AdminDashboardScreen',
  components: {
    'page-header': PageHeader,
    'base-button': BaseButton,
    'dashboard-card': DashboardCard,
    'activity-feed': ActivityFeed,
    'configurable-list': ConfigurableList,
    ActivityChart,
    ApexCharts,
    VueCal,
    BaseDropdown,
  },
  data() {
    return {
      notificationPages: 1,
      currentTimeLinePage: 1,
      searchTerm: '',
      dashboardData: undefined,
      localCategories: [],
      localSeries: [],
      timeLine: [],
      isLoading: true,
      tasks: [],
      siteId: undefined,
      sites: [],
      selectedSite: undefined,
      allSite: [],
    };
  },
  created() {
    this.loadingText = this.$t('app.listLoading');
    this.fetchSites({
      partnerId: this.loggedInUser.partner_id,
      pageIndex: null,
      searchTerm: '',
      orderInfo: {
        order: 'created_at',
        direction: 'ASC',
      },
      isMobile: true,
    }).then((r) => {
      this.allSite = r;
      this.selectedSite = r[0];
      this.sites = r.map(x => ({ value: x.id, text: this.$t(x.name) }));
      if (this.sites.length > 0) {
        this.siteId = this.sites[0].value;
      } else {
        this.siteId = null;
      }
      this.fetchTimeLine({
        id: this.loggedInUser.partner_id,
        type: 'partner',
        page: this.currentTimeLinePage,
      }).then((response) => {
        this.timeLine = response.notifications;
        this.notificationPages = response.total_pages;
      });
      this.fetchPartnerDashboard({ id: this.loggedInUser.partner_id, siteId: this.siteId }).then(
        (response) => {
          this.dashboardData = response;
          this.isLoading = false;
        },
      );
      this.fetchPartnerChartData({ id: this.loggedInUser.partner_id, siteId: this.siteId }).then((response) => {
        this.localCategories = response.categories;
        this.localSeries = response.series;
      });
      this.setTasks();
    });
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
      selectedLanguage: 'selectedLanguage',
    }),
    calendarLocale() {
      if (this.selectedLanguage === 'hu_HU') {
        return 'hu';
      }
      return 'en';
    },
    donutOptions() {
      const datas = this.dashboardData.task_info.tasks_by_status;
      const series = [];
      const labels = [];
      let sum = 0;
      Object.keys(datas).forEach((data) => {
        labels.push(this.$t(`app.dashboard.${data}`));
        if (datas[data] !== null) {
          series.push(datas[data]);
          sum += datas[data];
        } else {
          series.push(0);
          sum += 0;
        }
      });
      return {
        series,
        labels,
        sum,
      };
    },
    inspectionPercent() {
      if (this.dashboardData) {
        return (
          (this.dashboardData.inspection_info.completed_inspection_count /
            this.dashboardData.inspection_info.inspections_count) *
          100
        );
      }
      return 0;
    },
    options() {
      return {
        height:
          this.loggedInUser.role === 'admin'
            ? 'auto'
            : '490px',
        chart: {
          height: 300,
          animations: {
            enabled: false,
          },
          id: 'vuechart-example',
        },
        xaxis: {
          categories: this.localCategories,
        },
        stroke: {
          colors: ['#15326b'],
        },
      };
    },
    series() {
      return [
        {
          name: this.$t('app.dashboard.activity'),
          data: this.localSeries,
        },
      ];
    }
  },
  methods: {
    ...mapActions({
      fetchCalendarTasks: 'tasks/fetchCalendarTasks',
      fetchPartnerDashboard: 'dashboards/fetchPartnerDashboard',
      fetchPartnerChartData: 'partners/fetchPartnerChartData',
      fetchTimeLine: 'dashboards/fetchTimeLine',
      fetchSites: 'sites/fetchSites',
    }),
    filterBySite(site) {
      this.fetchPartnerDashboard({ id: this.loggedInUser.partner_id, siteId: site }).then(
        (response) => {
          this.siteId = site;
          this.selectedSite = this.allSite.filter(x => x.id === site);
          this.dashboardData = response;
          this.isLoading = false;
        },
      );
      this.fetchPartnerChartData({ id: this.loggedInUser.partner_id, siteId: site }).then((response) => {
        this.localCategories = response.categories;
        this.localSeries = response.series;
      });
      this.setTasks()
    },
    setTasks() {
      this.fetchCalendarTasks({keyword: this.searchTerm, siteId: this.siteId}).then((response) => {
        this.tasks = response.final_tasks.task_list.map((x) => {
          const date = new Date(x.deadline);
          if(!x.name && x.task_type && x.task_type === 'deflection') {
            return {
              title: this.$t('app.calendar.deflection'),
              data: {
                id: x.id,
                name: x.name === undefined || x.name === null ? this.$t('app.calendar.unset') : x.name,
                description: x.description === undefined || x.description === null ? this.$t('app.calendar.unset') : x.description,
                deadline: this.formatDate(date, true),
                identifier: x.identifier,
                type: x.type,
                site_id: x.site_id,
                task_type: x.task_type
              },
              start: this.formatDate(date),
              end: this.formatDate(date),
              class: x.status,
            }
          }
          if (!x.name && x.description) {
            return {
              title: x.description,
              data: {
                id: x.id,
                name:
                  x.name === undefined || x.name === null
                    ? this.$t('app.calendar.unset')
                    : x.name,
                description:
                  x.description === undefined || x.description === null
                    ? this.$t('app.calendar.unset')
                    : x.description,
                deadline: this.formatDate(date, true),
                identifier: x.identifier,
                type: x.type,
                site_id: x.site_id,
                task_type: x.task_type
              },
              start: this.formatDate(date),
              end: this.formatDate(date),
              class: x.status,
            };
          } else if (x.name) {
            return {
              title: x.name,
              data: {
                id: x.id,
                name:
                  x.name === undefined || x.name === null
                    ? this.$t('app.calendar.unset')
                    : x.name,
                description:
                  x.description === undefined || x.description === null
                    ? this.$t('app.calendar.unset')
                    : x.description,
                deadline: this.formatDate(date, true),
                identifier: x.identifier,
                type: x.type,
                site_id: x.site_id,
                task_type: x.task_type
              },
              start: this.formatDate(date),
              end: this.formatDate(date),
              class: x.status,
            };
          }
          return {
            title: x.identifier,
            data: {
              id: x.id,
              name:
                  x.name === undefined || x.name === null
                    ? this.$t('app.calendar.unset')
                    : x.name,
              description:
                  x.description === undefined || x.description === null
                    ? this.$t('app.calendar.unset')
                    : x.description,
              deadline: this.formatDate(date, true),
              identifier: x.identifier,
              type: x.type,
              site_id: x.site_id,
              task_type: x.task_type
            },
            start: this.formatDate(date),
            end: this.formatDate(date),
            class: x.status,
          };
        });
      });
    },
    loadNext(page) {
      this.fetchTimeLine({
        id: this.loggedInUser.partner_id,
        type: 'partner',
        page,
      }).then((response) => {
        this.timeLine = this.timeLine.concat(response.notifications);
        this.notificationPages = response.total_pages;
      });
    },
    onEventClick(event) {
      if (event.data.id === 0 && event.data.type === 0) {
        this.$swal
          .fire({
            html: '',
            type: 'info',
            showCloseButton: true,
            showCancelButton: true,
            showConfirmButton: true,
            focusConfirm: false,
            confirmButtonText: this.$t('app.calendar.goToInspections'),
            cancelButtonText: this.$t('app.calendar.goToTasks')
          })
          .then((result) => {
            if (result.value) {
              this.$router.push({
                name: 'InspectionsScreen',
              });
            } else if (result.dismiss && result.dismiss === 'cancel') {
              this.$router.push({
                name: 'TasksScreen',
              });
            }
          });
      } else if (event.data.id === 0 && event.data.type === 1) {
        this.$router.push({ name: 'InspectionsScreen' });
      } else if (event.data.id === 0 && event.data.type === 2) {
        this.$router.push({ name: 'TasksScreen' });
      } else if (event.data.type === 1) {
        this.$swal
          .fire({
            html: `<p class="name"><span class="title">${this.$t(
              'app.calendar.type',
            )}</span> ${this.$t('app.calendar.inspection')}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.identifier',
  )}</span> ${event.data.identifier}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.description',
  )}</span> ${event.data.description}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.deadline',
  )}</span> ${event.data.deadline}<p>`,
            type: 'info',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            focusConfirm: false,
            confirmButtonText: this.$t('app.calendar.goToInspections'),
          })
          .then((result) => {
            if (result.value) {
              this.$router.push({
                name: 'InspectionsScreen',
              });
            }
          });
      } else {
        this.$swal
          .fire({
            html: `<p class="name"><span class="title">${this.$t(
              'app.calendar.type',
            )}</span> ${event.data.task_type === 'deflection' ? this.$t('app.calendar.deflection') : this.$t('app.calendar.provision')}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.identifier',
  )}</span> ${event.data.identifier}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.description',
  )}</span> ${event.data.description}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.deadline',
  )}</span> ${event.data.deadline}<p>`,
            type: 'info',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            focusConfirm: false,
            confirmButtonText: this.$t('app.calendar.goToTasks'),
          })
          .then((result) => {
            if (result.value) {
              this.$router.push({
                name: 'TasksScreen',
                params: { id: event.data.id },
                query: { siteId: event.data.site_id },
              });
            }
          });
      }
    },
    formatDate(d, withoutTime) {
      if (withoutTime) {
        return [
          d.getFullYear(),
          (`0${d.getMonth() + 1}`).slice(-2),
          d.getDate(),
        ].join('-');
      }
      return (
        `${[d.getFullYear(), d.getMonth() + 1, d.getDate()].join('-')
        } ${
          [d.getHours(), d.getMinutes()].join(':')}`
      );
    },
    today() {
      return new Date();
    },
  }
};
</script>

<style lang="scss" scoped>
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-text {
  font-size: 20px;
}

.dasboard-row {
  min-height: 372px;
  margin-left: -4px;
  margin-right: -4px;
}

.date-col {
  padding: 5px;
}

.title {
  font-size: 20px;
}

.statements {
  display: flex;
  align-items: center;
}

.without-float {
  margin-top: 10%;
  float: none !important;
}

.rounded {
  border-radius: 4px;
}

.with-padding {
  padding-bottom: 10px;
}

.card-wrapper {
  padding-top: 10px;
  margin-left: 0;
}

.industry-title {
  line-height: 5px !important;
}

.donut-panel {
  max-height: 390px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/dashboard/AdminDashboard.vue